"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _bugsnagJs = _interopRequireDefault(require("bugsnag-js"));

var _bugsnagReact = _interopRequireDefault(require("bugsnag-react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var ErrorBoundaries = function ErrorBoundaries(props) {
  var bugsnagClient = (0, _bugsnagJs.default)({
    apiKey: props.apiKey,
    notifyReleaseStages: ['production'],
    releaseStage: process.env.NODE_ENV
  });
  var ErrorBoundary = bugsnagClient.use((0, _bugsnagReact.default)(React));
  return React.createElement(ErrorBoundary, null, props.children);
};

var _default = ErrorBoundaries;
exports.default = _default;